import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Icon } from "@/components/Icon";
import { useAppConfig } from "@/lib/use-app-config";

const TITLE = "Termeni și condiții — Asistent Auto";
const DESCRIPTION =
  "Termenii și condițiile de utilizare ai aplicației și site-ului Asistent Auto.";

export default function TermeniPage() {
  const { companyName, address, contactEmail } = useAppConfig();

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path="/termeni" />
      <header className="page-hero">
        <div className="shell">
          <div className="section-eyebrow">Legal</div>
          <h1>
            Termeni și<br />
            <em>condiții.</em>
          </h1>
          <p>
            Reguli aplicabile oricărei persoane care vizitează ori accesează
            aplicația, site-ul ori care utilizează, în orice mod, serviciile
            oferite de {companyName}.
          </p>
        </div>
      </header>

      <section className="section section--tight">
        <div className="shell">
          <div className="legal">
            <aside className="legal-toc">
              <h4>Cuprins</h4>
              <ol>
                <li>
                  <a href="#definitii">Definiții</a>
                </li>
                <li>
                  <a href="#rca">RCA</a>
                  <ol>
                    <li>
                      <a href="#cotatie">Cotație preț</a>
                    </li>
                    <li>
                      <a href="#comanda">Comandă</a>
                    </li>
                    <li>
                      <a href="#plata">Plata</a>
                    </li>
                    <li>
                      <a href="#garantie">Garanție și retur</a>
                    </li>
                    <li>
                      <a href="#anulare">Anulare poliță</a>
                    </li>
                    <li>
                      <a href="#disponibilitate">Disponibilitate</a>
                    </li>
                  </ol>
                </li>
                <li>
                  <a href="#drepturi">Drepturile de autor</a>
                </li>
                <li>
                  <a href="#legaturi">Legătura cu alte site-uri</a>
                </li>
                <li>
                  <a href="#modificari">Modificarea termenilor</a>
                </li>
              </ol>
            </aside>

            <article className="prose">
              <h2 id="definitii">
                <span className="num">1</span>Definiții
              </h2>
              <p>
                {companyName} a creat aplicația Asistent Auto ca aplicație
                gratuită. Acest serviciu este furnizat de {companyName} fără
                costuri și este destinat utilizării așa cum este. În cuprinsul
                acestor Termeni și condiții se stabilesc care sunt regulile
                obligatorii aplicabile oricărei persoane care vizitează ori
                accesează Aplicația, Site-ul ori care utilizează, în orice mod,
                serviciile oferite prin intermediul Aplicației sau Site-ului de
                către {companyName}. Prin următorii termeni folosiți se va
                înțelege:
              </p>

              <dl>
                <dt>Termeni și condiții</dt>
                <dd>Termenii și condițiile de utilizare</dd>
                <dt>Aplicația</dt>
                <dd>aplicația pentru mobil Asistent Auto</dd>
                <dt>Site-ul</dt>
                <dd>
                  site-ul{" "}
                  <a href="https://asistent-auto.ro">www.asistent-auto.ro</a>
                </dd>
                <dt>Serviciile Asistent Auto</dt>
                <dd>serviciile oferite prin intermediul Aplicației sau Site-ului</dd>
                <dt>Asistent Digital</dt>
                <dd>compania {companyName}</dd>
                <dt>Utilizator</dt>
                <dd>
                  orice persoană fizică sau juridică care accesează Site-ul sau
                  Aplicația
                </dd>
                <dt>Furnizor</dt>
                <dd>
                  Asigurătorul persoană juridică română sau străină ori
                  societatea mutuală autorizată în condițiile Legii nr. 32/2000
                  privind activitatea de asigurare și supravegherea asigurărilor
                  să exercite activități de asigurare
                </dd>
                <dt>Vânzător</dt>
                <dd>
                  Polițele RCA sunt emise în numele societăților de asigurare de
                  către INTER Broker de Asigurare SRL, înregistrată la Registrul
                  Comerțului sub nr. J05/1228/2011, C.I.F. 28647300, cod
                  înscriere Pensii Private: AMI-RO-28659757, număr înmatriculare
                  SAR: RBK-690/29.08.2011, înregistrat în registrul de evidență
                  a operatorilor de date cu caracter personal cu numărul 27870,
                  prin Asistent Digital, asistent în brokeraj, cod RAF 412007
                </dd>
                <dt>Comandă</dt>
                <dd>
                  document electronic (poliță de asigurare) ce intervine ca
                  formă de comunicare între vânzător și cumpărător, prin care
                  cumpărătorul transmite vânzătorului, prin intermediul
                  Aplicației, intenția sa de a achiziționa asigurări online
                  și/sau produse conexe (viniete, asistență rutieră etc)
                </dd>
                <dt>Cotație preț</dt>
                <dd>
                  calcularea estimativă a prețului asigurării sau a prețului
                  produsului conex (vinietă, asistență rutieră etc) pe baza
                  datelor oferite de utilizator, fără a fi necesară
                  autentificarea acestuia
                </dd>
                <dt>Ofertă</dt>
                <dd>
                  documentul emis de INTER Broker, în baza informațiilor
                  necesare încheierii unui contract de asigurare, furnizate de
                  utilizator, care conține informațiile prevăzute de Norma
                  15/2015
                </dd>
                <dt>Prestarea serviciilor pe cale electronică</dt>
                <dd>
                  efectuarea serviciilor, care au loc prin trimiterea și
                  preluarea datelor cu ajutorul sistemelor teleinformatice, la
                  cererea individuală a utilizatorului, fără prezența în același
                  timp a părților
                </dd>
              </dl>

              <h2 id="rca">
                <span className="num">2</span>RCA
              </h2>
              <p>
                Asistent Auto pune la dispoziția utilizatorilor o platformă
                prin care aceștia vor putea vedea cotații de preț pentru
                asigurări RCA și de asemenea vor putea achiziționa polițe RCA.
                Pentru a achiziționa asigurări este necesară autentificare în
                aplicație.
              </p>
              <p>Utilizatorul ia act de faptul că:</p>
              <ul>
                <li>
                  toate informațiile prezentate despre ofertele partenerilor sau
                  ale altor terți sunt introduse în cadrul platformei direct de
                  către aceștia sau sunt preluate din documente publice ale
                  acestora.
                </li>
                <li>
                  niciunul dintre materialele prezentate în Aplicație nu
                  constituie o ofertă sau cerere de cumpărare sau vânzare a
                  vreunui instrument financiar. În special, prețurile, valori
                  ale dobânzilor sau evaluările prezentate pe acest site sunt
                  doar orientative și nu constituie o ofertă a companiei
                  Asistent Digital sau a unui terț de a cumpăra sau a vinde
                  vreun instrument financiar la acel preț. Deși s-au luat
                  măsuri pentru a ne asigura că informațiile prezentate pe site
                  sunt corecte în momentul publicării, Asistent Digital (sau
                  orice terț care este prezent pe acest site) nu poate fi ținut
                  responsabil pentru claritatea sau gradul de completare ale
                  acestora.
                </li>
                <li>
                  materialele de pe acest site pot fi modificate fără
                  avertizări prealabile. Oricare dintre partenerii Asistent
                  Digital poate aduce modificări ofertelor sale și este posibil
                  să existe un anumit decalaj de timp între data efectuării
                  acestor modificări de către terți și data operării lor în
                  cadrul aplicației.
                </li>
              </ul>

              <h3 id="cotatie">2.1. Cotație preț</h3>
              <p>
                Pentru obținerea unei cotații de preț, datele introduse de
                către dumneavoastră în Aplicație vor fi transmise către
                societățile de asigurare, Furnizori. Pentru emiterea unui
                contract de asigurare vor fi utilizate datele introduse de
                către dumneavoastră în Aplicație, prin urmare, trebuie să
                furnizați informații corecte și complete de identificare pe
                care Aplicația le poate utiliza pentru emiterea poliței de
                asigurare, facturare și livrare. Contractele de asigurare se
                supun reglementărilor emise de către Comisia De Supraveghere a
                Asigurărilor împreună cu modificările ulterioare iar condițiile
                de asigurare sunt specifice fiecărui Furnizor în parte.
                Răspunderea în ceea ce privește contractele de asigurare
                precum și condițiile de asigurare revine societăților de
                asigurare emitente în integralitatea lor.
              </p>

              <h3 id="comanda">2.2. Comandă</h3>
              <p>
                Toate comenzile sunt efectuate exclusiv online. Pentru a
                efectua o comandă e nevoie ca utilizatorul să fie înregistrat
                și să aleagă o ofertă din partea unei companii de asigurări.
                Comanda este redirecționată către Furnizorul vizat, care
                confirmă primirea și acceptă Comanda respectivă sau indică
                faptul că acea Comandă nu poate fi acceptată, parțial sau
                integral. Confirmarea este redirecționată către Utilizator și
                polițele pentru care a fost acceptată Comanda sunt emise și
                ulterior livrate direct.
              </p>
              <p>
                Polițele de asigurări sunt documentele electronice salvate în
                format PDF, și vor fi transmise la adresa de e-mail a
                clientului și de asemenea disponibile prin intermediul
                Aplicației.
              </p>
              <p>
                Expedierea unui exemplar tipărit al poliței către adresa
                indicată de către cumpărător se face conform specificațiilor
                fiecărui tip de poliță de asigurare.
              </p>

              <h3 id="plata">2.3. Plata</h3>
              <p>
                Plata în Aplicație se poate face doar online cu cardul în
                contul INTER Broker de Asigurare, înregistrat la Registrul
                Comerțului sub nr. J05/1228/2011, C.I.F. 28647300. Pentru
                efectuarea plății online, Utilizatorul este direcționat pe
                pagina securizată de internet a procesatorului de plăți online,
                unde are loc autorizarea tranzacției. Plățile cu cardul sunt
                procesate prin intermediul IPAY de la Banca Transilvania.
              </p>

              <h3 id="garantie">
                2.4. Condiții de garanție și politica de returnare/modificare a
                polițelor
              </h3>
              <p>
                În cazul polițelor de asigurare RCA, Utilizatorul confirmă că
                datele și informațiile introduse pe soluția Asistent Auto sunt
                conforme cu cele din certificatul de înmatriculare, precum și
                faptul că persoana menționată în formularul de comandă este
                proprietarul autovehiculului. Utilizatorul își asumă întreaga
                răspundere privind datele furnizate și acceptă faptul că
                Operatorul nu va fi ținut răspunzător față de Utilizator și/sau
                față de terți pentru prejudiciile de orice natură rezultate ca
                urmare a furnizării unor informații eronate de către
                Utilizator.
              </p>
              <p>
                Utilizatorul garantează și își asumă răspunderea pentru plata
                poliței/polițelor de asigurare comandate, în condițiile și
                modalitățile stipulate.
              </p>
              <p>
                Asigurătorii care au fost autorizați să practice anumite clase
                de asigurări își asumă răspunderea pentru toate polițele și
                pentru toate erorile sau omisiunile apărute la emiterea
                polițelor de asigurare fie direct, fie prin intermediarii în
                asigurări. Se poate solicita returul/modificarea poliței de
                asigurare livrate doar în situația în care datele din polița
                livrată nu corespund cu cele introduse de client în formularul
                de comandă. Costurile de retur vor fi suportate de către{" "}
                {companyName}. Adresa la care se returnează polițele este:{" "}
                {address}.
              </p>

              <h3 id="anulare">2.5. Anulare poliță</h3>
              <p>
                În privința asigurărilor obligatorii prin norme legale,
                denunțarea sau renunțarea utilizatorului (în calitate de
                contractant sau de asigurat) la contract se poate face doar în
                condițiile specificate în actele normative care reglementează
                respectiva asigurare, completate cu prevederile contractului de
                asigurare, dacă este cazul.
              </p>
              <p>
                În cazul asigurărilor obligatorii de răspundere civilă pentru
                prejudicii produse prin accidente de vehicule, se aplică
                reglementările specifice acestei asigurări.
              </p>
              <p>
                În cazul în care contractul de asigurare a început să își
                producă efectele în perioada de notificare, prima de asigurare
                va fi restituită pro rata și în măsura în care nu s-au produs
                evenimente asigurate și/sau nu există daune avizate în baza
                respectivului contract / poliță de asigurare.
              </p>
              <p>
                În cazul în care s-au înregistrat daune înainte de renunțarea
                la contract prevăzută în prezentul Capitol, primele de
                asigurare pentru perioada rămasă până la expirare nu se mai
                restituie.
              </p>
              <p>
                Solicitarea renunțării la un contract se face prin trimiterea
                unei cereri de anulare prin intermediul emailului la adresa{" "}
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                .
              </p>
              <p>
                Termenul de restituire a primelor de asigurare în cazul
                polițelor/contractelor de asigurare este de 30 de zile
                calendaristice de la primirea notificării denunțării de către
                utilizator și se va face prin intermediul INTER Broker de
                Asigurare.
              </p>

              <h3 id="disponibilitate">2.6. Disponibilitate</h3>
              <p>
                Serviciile de Asigurare RCA sunt disponibile, numai în România,
                cetățenilor români, cu vârsta peste 18 ani, persoanelor cu
                rezidență permanentă în România sau persoanelor străine cu
                rezidență în România.
              </p>

              <h2 id="drepturi">
                <span className="num">3</span>Drepturile de autor
              </h2>
              <p>
                Drepturile de autor asupra întregului conținut al site-ului și
                aplicației aparțin Asistent Digital. Copierea sau reproducerea
                acestuia fără acordul scris al Asistent Digital este strict
                interzisă și este supusă sancțiunilor prevăzute de Legea nr.
                8/1996. În cazul în care în cuprinsul aplicației sau site-ului
                sunt efectuate referiri către un conținut extern, drepturile de
                autor aparțin persoanei sau persoanelor indicate în respectivul
                conținut, conform legii aplicabile. Eventuala încălcare a
                drepturilor de autor va fi sesizată folosind adresa{" "}
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                .
              </p>
              <p>
                Accesând acest site, îți exprimi acordul ca Asistent Auto să
                poată prelucra datele cu caracter personal, dezvăluite ca
                urmare a folosirii serviciului, în conformitate cu termenii și
                condițiile prevăzute în cadrul paginii{" "}
                <Link to="/confidentialitate">
                  „Politica de confidențialitate&rdquo;
                </Link>
                .
              </p>

              <h2 id="legaturi">
                <span className="num">4</span>Legătura cu alte site-uri
              </h2>
              <p>
                Serviciul nostru poate conține legături către alte site-uri web
                care nu sunt operate de noi. Dacă faceți clic pe un link terț,
                veți fi direcționat către site-ul respectiv. Vă recomandăm cu
                tărie să consultați politica de confidențialitate a fiecărui
                site pe care îl vizitați.
              </p>
              <p>
                Nu avem niciun control și nu ne asumăm nici o responsabilitate
                pentru conținutul, politicile de confidențialitate sau
                practicile site-urilor sau serviciilor terților.
              </p>

              <h2 id="modificari">
                <span className="num">5</span>Modificarea termenilor și
                condițiilor
              </h2>
              <p>
                Asistent Auto poate modifica prezentele condiții la anumite
                intervale de timp. Aceste modificări vor fi aduse la
                cunoștința utilizatorului prin intermediul Site-ului și
                Aplicației, fără a fi necesară vreo altă modalitate de
                notificare. Modificările făcute astfel sunt socotite a fi
                acceptate de către utilizator dacă acesta continuă să folosească
                serviciul după afișarea lor pe site sau în aplicație.
              </p>

              <div className="legal-meta">
                <span>
                  <b>Operator:</b> {companyName} · {address}
                </span>
                <span>
                  <b>Contact:</b>{" "}
                  <a href={`mailto:${contactEmail}`} style={{ color: "inherit" }}>
                    {contactEmail}
                  </a>
                </span>
              </div>

              <Link className="legal-cross" to="/confidentialitate">
                <span>
                  Vezi și modul în care prelucrăm datele tale personale.
                </span>
                <span className="legal-cross-link">
                  Politica de confidențialitate
                  <Icon name="arrow_forward" />
                </span>
              </Link>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}
